import React, { Component } from 'react';
import { helpers } from 'react-redux-firebase';
const { isLoaded } = helpers;

import MetricsPanelListItem from './MetricsPanelListItem';
import { keyedObjToArr } from '../../util/index';

import './metrics.scss';
import '../../../sass/components/ui-list';

export default class MetricsPanelList extends Component {

	constructor (props) {
		super(props);
	}

	render () {
		if (!isLoaded(this.props.profile) ||
            !isLoaded(this.props.classrooms) ||
            !isLoaded(this.props.products) ||
            !isLoaded(this.props.orders)){
		    return(<div>Loading</div>);
        }

        let classrooms = this.props.classrooms;
		return (
			<div className="metrics-list">
                {classrooms.map( (classroom, index)=> {
                    let product = keyedObjToArr(this.props.products).find( (productItem)=> {
                        return productItem.productId === classroom.product;
                    }, this);
                    let order = keyedObjToArr(this.props.orders).find( (orderItem) => {
                       if (orderItem.customer === this.props.profile.customer && (orderItem.status === 'active' || orderItem.status == 'trial')){
                           let products = keyedObjToArr(orderItem.products);
                           if (products[0].productId === classroom.product)
                               return true;
                       }
                       return false;
                    }, this);
                    return(
						<MetricsPanelListItem
							key={index}
							classroom={classroom}
							product={product}
							order={order}
							selectedClassroom={this.props.selectedClassroom}
						/>
                    );
                })}
			</div>
		);
	}
}



// WEBPACK FOOTER //
// ./js/components/Metrics/MetricsPanelList.js